<template>
  <div class="description">
    <div :class="`pic ${position}`"></div>
    <div class="content">
      {{ contents[position] }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: "80px"
    },
    height: {
      type: String,
      default: "86px"
    },
    position: {
      type: String,
      default: "reportList"
    }
  },
  data() {
    return {
      contents: {
        reportList:
          "个人信息报告主要用于个人增信展示或提供给他人查验。您在生成个人信息报告时，可针对您的个人数据档案勾选全部或部分数据生成不同版本的信息报告，报告依据截至报告时点的全国人力资源信息数据验证平台记录的数据档案生成，报告内容不可修改。",
        reportCheckList:
          "他人向您发起的查验申请，您可以在查验申请页面中查看和处理。同意申请人查看，可选择并授权您的个人信息报告。开通年费会员可设置默认应答操作，选择每次都询问、每次都同意、每次都拒绝等应答模式。"
      }
    };
  }
};
</script>

<style scoped lang="scss">
.description {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #7986a0;
  line-height: 24px;
  padding: 14px 30px 15px 26px;
  background: #f7f9fd;
  display: flex;
  align-items: center;
//   .pic {
//     margin-right: 43px;
//   }
  .content {
    flex: 1;
  }
  .reportList {
    background: url("../assets/reportList_pic1.png");
    background-size: cover;
    width: 80px;
    height: 86px;
    margin-right: 43px;
  }
  .reportCheckList {
    background: url("../assets/reportCheckList_pic1.png");
    background-size: cover;
    width: 108px;
    height: 80px;
    margin-right: 19px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PageDescription.vue